export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/UserIcon.95bff7f0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};